module.exports = __webpack_public_path__ + "static/media/photo8.7fb230dc.jpg";